import {createApiQuery, useApiMutation} from './api';
import {
  GetScoringInfo,
  RefreshAccounts,
} from '../../shared/api/definitions/scoredAccounts';
import {useIsFreemiumCustomer} from './metadata';
import {useQueryClient} from '@tanstack/react-query';
import {MetadataQueryKey} from '../../context/MetadataContext';

export const ScoringInfoQueryKey = 'scoringInfo';

const useGetScoringInfo = createApiQuery(GetScoringInfo, () => [
  ScoringInfoQueryKey,
]);

export const useScoringInfo = () => {
  const isFreemiumCustomer = useIsFreemiumCustomer();
  return useGetScoringInfo(
    {},
    {
      refetchInterval: (query) => {
        // No need to refetch if we aren't scoring
        if (!query.state.data?.runningRefresh) {
          return 0;
        }

        // For free customers, we expect scoring to happen very quickly so we can refetch often.
        return isFreemiumCustomer ? 1_000 : 12_000;
      },
    }
  );
};

export function useIsRescoring() {
  const {data} = useScoringInfo();
  return !!data?.runningRefresh;
}

export const useRefreshAccounts = () => {
  const queryClient = useQueryClient();

  return useApiMutation(RefreshAccounts, {
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [ScoringInfoQueryKey],
        }),
        // in case active market was changed
        queryClient.invalidateQueries({
          queryKey: [MetadataQueryKey],
        }),
      ]);
    },
  });
};
